import { render, staticRenderFns } from "./SkeletonMiniWizardSticky.vue?vue&type=template&id=714c4710"
import script from "./SkeletonMiniWizardSticky.vue?vue&type=script&lang=js"
export * from "./SkeletonMiniWizardSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports